import React, { useEffect, useCallback, useContext } from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { WizardPageTemplate } from 'gw-portals-wizard-components-ui';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { ModalNextContext, Tooltip,Icon } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import FNOLLossLocation from '../../components/LossLocation/LossLocation';
import metadata from './WherePage.metadata.json5';
import messages from '../../FNOL.messages';
import usecpmiAnalytics from '../../../../hooks/usecpmiAnalytics'
import useGoogleAnalytics from '../../../../hooks/useGoogleAnalytics';

function FNOLWherePage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        },authHeader
    } = props;
    const translator = useTranslator();
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();
    const { FNOLService } = useDependencies('FNOLService');
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        registerInitialComponentValidation
    } = useValidation('FNOLWherePage');

    useEffect(()=> {
        trackPageView("Where",'/where')
    },[])

    useEffect(() => {
        trackGAPageView('/where', 'FNOL Where');
    },[])

    const ModalNext=useContext(ModalNextContext);

    const onNext = useCallback(() => {
        const newClaimVM = _.clone(claimVM);
        _.set(newClaimVM, 'documents.value', []);
        return FNOLService.saveFNOLDetails(newClaimVM.value, authHeader)
            .then((response) => {
                claimVM.value = response;
                return claimVM;
            })
            .catch(() => {
                ModalNext.showAlert({
                    title: messages.fnolSaveDraftErrorTitle,
                    message: messages.fnolSaveDraftErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: 'Ok'
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                //  setIsLoading(false);
            });
    }, [FNOLService, ModalNext, authHeader, claimVM]);

    const overrideProps = {
        lossLocationComponent: {
            path: !_.isUndefined(claimVM) ? claimVM : null,
            updatePath: updateWizardData
        }
    };

    const resolvers = {
        resolveComponentMap: {
            losslocationcomponent: FNOLLossLocation
        },
        resolveCallbackMap: {
            onValidate: onValidate
        }
    };


    
   
    const validateClaimStatus = useCallback(() => {
        const { claimStatus } = state;
        return !_.isNil(claimStatus);
    }, [state]);
   

    useEffect(() => {
        registerInitialComponentValidation(validateClaimStatus);
    }, [validateClaimStatus, registerInitialComponentValidation]);

    const getValidation=useCallback(()=>{
        if(isComponentValid)
        {
            
            if(claimVM.value.lossLocation&&claimVM.value.lossLocation.postalCode&&claimVM.value.lossLocation.postalCode.length>0)
            {
                return false 
            }
            
            return true
            
       
        }
        if(isComponentValid===false)
        {
            return true
        }
    },[claimVM.value, isComponentValid])

    return (
        <WizardPage
            cancelLabel={translator(messages.fnolSaveandExit)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            onNext={onNext}
            disableNext={getValidation()} 
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                onValidationChange={onValidate}
            />
        </WizardPage>
    );
}
FNOLWherePage.propTypes = wizardProps;
export default withRouter(withAuthenticationContext(FNOLWherePage));
